import api from "../../../api/axios";

// Feature-local wrappers for the Task endpoints used by the
// /clients/:clientId parent surface (Phase S8 — T-3 create-task
// continuation).
//
// Endpoints (per backend/app/apps/clients/views.py TaskViewSet):
//   GET  /api/crm/tasks/?client=<id>
//          — IsAuthenticated; queryset filtered to tasks where the
//            requesting user is assignee OR creator. Returns
//            TaskSerializer payloads ordered by -created_at.
//   POST /api/crm/tasks/
//          — IsAuthenticated; perform_create enforces
//            get_writable_client_or_403 when `client` is supplied
//            and defaults `assigned_to` to the requesting user.
//          — Body fields the serializer accepts on write:
//              title        (string, required, <=255 chars)
//              description  (string, optional)
//              status       (TaskStatus, optional — defaults to "todo")
//              priority     (TaskPriority, optional — defaults "medium")
//              due_date     (ISO datetime, optional, nullable)
//              client_id    (int, write-only — source=client)
//              assigned_to_id (int, write-only, optional)
//
// Feature-local copy by convention. Stateless request wrappers —
// no cache, no retry, no invalidation. The POST helper is consumed
// only by [[ClientCreateTaskModal]]; the section's own refresh path
// ([[ClientTasksSection]].handleReload) handles post-success
// freshness. No cross-section refresh; no orchestration.

export const fetchTasksForClient = (clientId) =>
  api
    .get(`/crm/tasks/`, { params: { client: clientId } })
    .then((res) => res.data);

export const createTask = (body) =>
  api.post(`/crm/tasks/`, body).then((res) => res.data);
